import validator from 'validator';

export const validateEmail = (value: string): string => {
	if (value.trim() === '') return 'Email can not be empty';
	if (!validator.isEmail(value)) {
		return 'Email is not valid';
	}
	return '';
};

export const validateField = (value: string): string => {
	if (value.trim() === '') return 'Field can not be empty';
	if (value.length < 2) return 'Value should be at least 2 chars long';
	return '';
};
